
import { Directive, ElementRef, HostListener, Input, AfterViewInit } from '@angular/core';
// import * as XLSX from 'xlsx';

import { GlobalUtilService } from '@otas/core/services/global-util.service';
import { isTauri } from '@tauri-apps/api/core';
import { FileSaverService } from 'ngx-filesaver';
import { ToasterService } from '../../services/toaster.service';
declare const Buffer;

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[print]',
    standalone: false
})
export class PrintElementDirective implements AfterViewInit {
    @Input() print;
    @Input() type;
    @Input() tableData;
    constructor( private globalUtilService: GlobalUtilService, private fileSaverService: FileSaverService,
        private toastr: ToasterService) {
    }
    ngAfterViewInit() {
    }
    @HostListener('click')
    async onClick() {
        if (!this.type || this.type === 'print') {
            console.log('printing...' + this.tableData);
            
            let pdfData = null;
            if (this.tableData) {
                // Handle pre-rendered PDF (Uint8Array or similar)
                pdfData = btoa(new Uint8Array(this.tableData).reduce(function (data, byte) {
                    return data + String.fromCharCode(byte);
                }, ''));
            } else {
                // Instant browser/OS printing instead of html2canvas lag
                this.globalUtilService.IPCRendererSend('handlePrintRequest');
                return;
            }

            if (pdfData != null) {
                if (isTauri()) {
                    this.toastr.info('Sending to printer...', 'Print');
                } else {
                    this.toastr.info('Opening print preview...', 'Print');
                }
                this.globalUtilService.IPCRendererSend('printdemo', pdfData);
            } else {
                this.toastr.warning('No data available for printing', 'Print');
            }
        }
    }
    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
        this.fileSaverService.save(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }
}
